import { formatDuration } from '@/conference/call-duration';

const SIZE_UNITS = ['byte', 'kilobyte', 'megabyte', 'gigabyte'] as const;

export function formatDate(isoDate: string, language: string): string {
    try {
        return new Intl.DateTimeFormat(language, {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        }).format(new Date(isoDate));
    } catch {
        return isoDate;
    }
}

export function formatSize(bytes: number, language: string): string {
    const exponent = bytes > 0 ? Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), SIZE_UNITS.length - 1) : 0;
    return new Intl.NumberFormat(language, {
        style: 'unit',
        unit: SIZE_UNITS[exponent],
        maximumFractionDigits: exponent > 0 ? 1 : 0,
    }).format(bytes / Math.pow(1024, exponent));
}

export function formatRecordingDuration(durationMs: number | null): string {
    return durationMs === null ? '—' : formatDuration(Math.round(durationMs / 1000));
}
